module.exports = __webpack_public_path__ + "img/EuclidEnercity-Light-WebS.a146dde9.svg";